import { useState, useEffect } from 'react';

//Breadcrumb
import IntentDrawer from '../../Common/IntentDrawer'
import Breadcrumb from '../../Common/Breadcrumb';
import IntentsTable, { IntentsColumnConfig } from '../../Common/IntentsTable'
import ConfirmModal from '../../Common/ConfirmModal';
import IntentMergeModal, { IntentMergeButton } from '../../Common/IntentMergeModal';
import IntentAggregations from '../../Common/IntentAggregations'
import { APIClient } from "../../helpers/api_helper";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { Button, Card, Col, Space, Tooltip } from 'antd';
import {PlusOutlined, DeleteOutlined, EditOutlined, DownloadOutlined} from '@ant-design/icons';
import { setFilterData, setInitialFilterConf, updateFilterData } from '../../slices/filters/thunk'
import utils from '../../Common/utils';
import { useIntentSelection } from '../../Common/Hooks/IntentSelectionHooks';


const api = new APIClient();


const Intents = () => {
  document.title = "Transakcije" + process.env.REACT_APP_PAGE_TITLE;

  const dispatch = useDispatch();
  const filterdata = useSelector((state) => state.Filterdata.data)
  const [intentsData, setIntentsData] = useState([{'results': []}]);
  const [intentAggsData, setIntentAggsData] = useState({});
  const selection = useIntentSelection({
    filters: utils.getObjectFromURL(),
    total: intentsData?.pagination?.count,
    pageIds: intentsData?.results?.map(r => r.id),
  });
  const { selectedIds, setSelectedIds, allMatching, setAllMatching, count: selectedCount } = selection;
  const [open, setOpen] = useState(false);
  const [massEditOpen, setMassEditOpen] = useState(false);
  const [showDeletionConfirmModal, setShowDeletionConfirmModal] = useState(false);
  const [mergeOpen, setMergeOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [editedIntentId, setEditedIntentId] = useState(null);
  const [exportLoading, setExportLoading] = useState(false);
  // Hosted up in the card header next to the other actions, rather than floating
  // above the table; IntentsTable runs off this same state.
  const [columnEditMode, setColumnEditMode] = useState(false);
  const [loading, setLoading] = useState(false);



  // `silent` skips the table spinner: an inline cell save reloads to pick up
  // its side effects (totals, DDV rows, the other transfer leg), and the row
  // already shows the saved value.
  const loadIntentsData = ({ silent = false } = {}) => {
    const filterdata = utils.getObjectFromURL()

    if (!silent) setLoading(true);
    api.get('/api/intents/', filterdata)
      .then(resp => setIntentsData(resp))
      .finally(() => setLoading(false));
    api.get('/api/insights/current_income_expense_sums/', filterdata).then(resp => {
      setIntentAggsData(resp)
    })
  }

  const handleExport = () => {
    const params = utils.cleanEmpty(
      !allMatching && selectedIds.length > 0
        ? { ids: selectedIds.join(',') }
        : utils.getObjectFromURL()
    );
    setExportLoading(true);
    axios.get(`/api/intents/export_xlsx/`, { params, responseType: 'blob' })
      .then(blob => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'intents.xlsx';
        a.click();
        URL.revokeObjectURL(url);
      })
      .finally(() => setExportLoading(false));
  }

  const handleConfirmedDelete = () => {
    const { qs, body, count } = selection.scope;
    setDeleting(true);
    api.delete(`/api/intents/delete_bulk/${qs}`, body, {successMsg: `Uspešno izbrisanih ${count} transakcij`})  // keep 'data', server will handle it diferently than POST!
      .then(resp => {
        setShowDeletionConfirmModal(false);
        selection.clear();
        loadIntentsData()
      })
      .catch(error => {
        console.error(error)
      })
      .finally(() => setDeleting(false));
  }


  useEffect(() => {
    dispatch(setInitialFilterConf({
      data: {
        // No default period: the list opens (and "clear filters" resets) to
        // all years, with no year preselected.
        'date_range': null,
        'hidden': [],
        'disabled': []
      },
      masterSearch: true,
    }))
    dispatch(setFilterData(utils.getObjectFromURL()))
  }, []);


  useEffect(() => {
    loadIntentsData()
  }, [filterdata]);


  return (
    <>
      <Breadcrumb parentTitle="" pageTitle={utils.getObjectFromURL().override_page_title || "Transakcije"} />

      <IntentAggregations data={intentAggsData} showExploreLinks showAllTypes />

      <IntentDrawer
        open={open}
        onCancel={() => {
          setOpen(false);
          setEditedIntentId(null);
        }}
        onDone={() => {
          loadIntentsData(filterdata);
          setEditedIntentId(null);
          setOpen(false);
        }}
        onIntentChanged={() => loadIntentsData(filterdata)}
        onOpenIntent={(id) => {
          setEditedIntentId(id);
          setOpen(true);
        }}
        editedIntentId={editedIntentId}
      />

      <IntentDrawer
        open={massEditOpen}
        massEdit={true}
        massEditScope={selection.scope}
        onCancel={() => setMassEditOpen(false)}
        onDone={() => {
          loadIntentsData(filterdata);
          setMassEditOpen(false);
        }}
        editedIntentId={null}
      />

      <>
        <Col xs={24} className="gutter-row">

          <Card
            title='Seznam transakcij'
            extra={
              <Space>
                <IntentsColumnConfig
                  editMode={columnEditMode}
                  setEditMode={setColumnEditMode}
                />
                <Tooltip title="Množično urejanje">
                  <Button
                    disabled={selectedCount == 0}
                    onClick={() => setMassEditOpen(true)}
                    icon={<EditOutlined />}
                  />
                </Tooltip>
                <IntentMergeButton
                  ids={selection.explicitIds}
                  onClick={() => setMergeOpen(true)}
                />
                <Tooltip title="Izbriši izbrane">
                  <Button
                    disabled={selectedCount == 0}
                    onClick={ev => {
                      setShowDeletionConfirmModal(true);
                    }}
                    icon={<DeleteOutlined />}
                  />
                </Tooltip>
                <Tooltip title="Izvozi v Excel">
                  <Button
                    loading={exportLoading}
                    disabled={exportLoading}
                    onClick={handleExport}
                    icon={<DownloadOutlined />}
                  />
                </Tooltip>
                <Tooltip title="Dodaj transakcijo">
                  <Button
                    onClick={ev => {
                      setEditedIntentId(null)
                      setOpen(true)
                    }}
                    icon={<PlusOutlined />}
                  />
                </Tooltip>
              </Space>
            }
          >
              <IntentsTable
                page={filterdata.page}
                loading={loading}
                intentsData={intentsData}
                columnEditMode={columnEditMode}
                onColumnEditModeChange={setColumnEditMode}
                onPageChange={pInx => dispatch(updateFilterData({page: pInx}))}
                selectedIds={selectedIds}
                setSelectedIds={setSelectedIds}
                allMatchingSelected={allMatching}
                setAllMatchingSelected={setAllMatching}
                onIntentEdit={r => {
                  setEditedIntentId(r.id)
                  setOpen(true);
                }}
                onIntentChanged={() => loadIntentsData({ silent: true })}
              />
            </Card>
        </Col>
        <IntentMergeModal
          open={mergeOpen}
          ids={selection.explicitIds}
          onCancel={() => setMergeOpen(false)}
          onMerged={() => {
            setMergeOpen(false);
            selection.clear();
            loadIntentsData();
          }}
        />
        <ConfirmModal
          textComponent={<p>{allMatching
            ? `Ali ste prepričani, da želite izbrisati vseh ${selectedCount} transakcij, ki ustrezajo filtrom (vse strani)?`
            : `Ali ste prepričani, da želite izbrisati ${selectedCount} transakcij?`}</p>}
          open={showDeletionConfirmModal}
          confirmBtnTitle='Izbriši'
          confirmBtnProps={{'danger': true}}
          loading={deleting}
          onOk={() => handleConfirmedDelete()}
          onCancel={() => {
            setShowDeletionConfirmModal(false);
          }}
        />

      </>
    </>
  )
}

export default Intents;
